import React from 'react';

import { ProductGroupFragment } from '@occc/graphql';
import {
  FormInputProps,
  defaultMakeFilter,
  mapRawResponseItemToAutocompleteOption,
  LazyAutocompleteFieldNotMultiple,
  ILazyAutocompleteFieldProps,
} from '@occc-app/design-system';
import { useChainId } from '@occc-app/Chain/hooks';
import { useGetProductGroupsLazy } from '@occc-app/dataAccessLayer/productGroup/queries';

const inputProps: FormInputProps = { margin: 'none' };
const FIRST = 100;

export interface ProductGroupSelectNotMultipleProps {
  label: string;
  name: string;
  disabled?: boolean;
}

export const ProductGroupSelectNotMultiple: React.FC<ProductGroupSelectNotMultipleProps> = ({
  label,
  name,
  disabled = false,
}) => {
  const chainId = useChainId();

  const makeQueryFilter = React.useCallback<
    NonNullable<
      ILazyAutocompleteFieldProps<
        ProductGroupFragment,
        ReturnType<typeof useGetProductGroupsLazy>['response']
      >['makeQueryFilter']
    >
  >((autocompleteInputValue) => defaultMakeFilter(chainId, autocompleteInputValue), [chainId]);

  return (
    <LazyAutocompleteFieldNotMultiple<
      ProductGroupFragment,
      ReturnType<typeof useGetProductGroupsLazy>['response']
    >
      name={name}
      label={label}
      useLazyQuery={useGetProductGroupsLazy}
      makeQueryFilter={makeQueryFilter}
      mapQueryResponseToRawArray={(response) => response.data || []}
      mapRawResponseItemToAutocompleteOption={mapRawResponseItemToAutocompleteOption}
      inputProps={inputProps}
      first={FIRST}
      disabled={disabled}
    />
  );
};
